import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppStore, User } from '@app/models';
import { LocalBusinesses } from '@app/models/LocalBusiness';
import { StoreProvider } from '@app/providers';
import { UserServices } from '@app/services';
import { Observable } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-edit-favorite-localbusiness',
    templateUrl: './edit-favorite-localbusiness.component.html',
    styleUrls: ['./edit-favorite-localbusiness.component.scss'],
})
export class EditFavoriteLocalbusinessComponent {
    public $app: Observable<AppStore> = this.$store.listen('app');
    constructor(
        private $store: StoreProvider,
        private userService: UserServices,
        private router: Router
    ) {}

    public editFavoriteLocalBusiness(
        user: User,
        localBusiness: LocalBusinesses
    ) {
        this.userService
            .postUserFavoriteLobalBusiness(user, localBusiness)
            .subscribe(() => {
                this.$store.emit({
                    app: {
                        props: {
                            favorite: localBusiness,
                            selectedLocalBusiness: localBusiness,
                        },
                    },
                });
                this.router
                    .navigate(['/counting'])
                    .then(() => window.location.reload());
            });
    }
}
